import type { Dict } from '../utils'

import { createContext } from '../utils'

const [RadioGroupProvider, useRadioGroupContext] = createContext<Dict>({ isOptional: true })

export { RadioGroupProvider, useRadioGroupContext }
